import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_COLLECTIVITES } from '../../../../config/aides-collectivites';

export default function DetrDsilPage() {
  const aide = AIDES_COLLECTIVITES.find((a) => a.slug === 'detr-dsil');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="collectivites" />;
}
